"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSwapToDates = exports.getSwapRequestsToDatesForDay = exports.getSwapToDatesForDay = exports.getSwapRequestsForDayFromMap = exports.getSwapsForDayFromMap = exports.generateSwapRequestsToDaysMap = exports.generateSwapToDaysMap = void 0;
var luxon_1 = require("luxon");
// TODO: Remove once shift match migration has been completed
var generateSwapToDaysMap = function (swaps, swapTypes) {
    if (!swaps.length || !swapTypes.length)
        return {};
    return swaps.reduce(function (acc, swap) {
        if (swapTypes.includes(swap.status) &&
            luxon_1.DateTime.fromISO(swap.swapFrom).isValid) {
            var swapFromISODate = luxon_1.DateTime.fromISO(swap.swapFrom).toISODate();
            if (!acc[swapFromISODate]) {
                acc[swapFromISODate] = [];
            }
            acc[swapFromISODate].push(swap);
        }
        return acc;
    }, {});
};
exports.generateSwapToDaysMap = generateSwapToDaysMap;
var generateSwapRequestsToDaysMap = function (swapRequests, swapTypes) {
    if (!swapRequests.length || !swapTypes.length)
        return {};
    return swapRequests.reduce(function (acc, swapRequest) {
        if (swapTypes.includes(swapRequest.status) &&
            luxon_1.DateTime.fromISO(swapRequest.from.shifts[0].timeRange.start).isValid) {
            var swapFromISODate = luxon_1.DateTime.fromISO(swapRequest.from.shifts[0].timeRange.start).toISODate();
            if (!acc[swapFromISODate]) {
                acc[swapFromISODate] = [];
            }
            acc[swapFromISODate].push(swapRequest);
        }
        return acc;
    }, {});
};
exports.generateSwapRequestsToDaysMap = generateSwapRequestsToDaysMap;
// TODO: Remove once shift match migration has been completed
var getSwapsForDayFromMap = function (swapsToDaysMap, date) {
    return (swapsToDaysMap && swapsToDaysMap[date.toISODate()]) || [];
};
exports.getSwapsForDayFromMap = getSwapsForDayFromMap;
var getSwapRequestsForDayFromMap = function (swapRequestsToDaysMap, date) {
    return ((swapRequestsToDaysMap && swapRequestsToDaysMap[date.toISODate()]) || []);
};
exports.getSwapRequestsForDayFromMap = getSwapRequestsForDayFromMap;
// TODO: Remove once shift match migration has been completed
var getSwapToDatesForDay = function (swapsToDaysMap, date) {
    return (0, exports.getSwapsForDayFromMap)(swapsToDaysMap, date)
        .map(function (swap) { return luxon_1.DateTime.fromISO(swap.swapTo); })
        .sort(function (a, b) { return (a < b ? -1 : 1); });
};
exports.getSwapToDatesForDay = getSwapToDatesForDay;
var getSwapRequestsToDatesForDay = function (swapRequestsToDaysMap, date) {
    return (0, exports.getSwapRequestsForDayFromMap)(swapRequestsToDaysMap, date)
        .map(function (swapRequest) {
        return luxon_1.DateTime.fromISO(swapRequest.to.shifts[0].timeRange.start);
    })
        .sort(function (a, b) { return (a < b ? -1 : 1); });
};
exports.getSwapRequestsToDatesForDay = getSwapRequestsToDatesForDay;
var getSwapToDates = function (swapFromScheduleDay) {
    return swapFromScheduleDay.swappableDays.reduce(function (total, current) {
        var _a;
        if (luxon_1.DateTime.fromISO(current.date).isValid &&
            !((_a = current.swapOpportunities) === null || _a === void 0 ? void 0 : _a.length)) {
            total.push(luxon_1.DateTime.fromISO(current.date));
        }
        return total;
    }, []);
};
exports.getSwapToDates = getSwapToDates;
